import { Component, OnInit, OnDestroy } from '@angular/core';
import { WebphoneService, WebphoneQuery, CallingState } from '@etop/state/shop/webphone';
import { Observable } from 'rxjs';
import { PageBaseComponent } from '@etop/web';
import { Router } from '@angular/router';
import { AuthenticateStore } from '@etop/core';
import { takeUntil } from 'rxjs/operators';
import { HotlineQuery, HotlineService } from '@etop/state/shop/hotline';
import { Hotline } from '@etop/models';

@Component({
  selector: 'etelecom-cs-webphone-dialer',
  templateUrl: './webphone-dialer.component.html',
  styleUrls: ['./webphone-dialer.component.scss']
})
export class WebphoneDialerComponent extends PageBaseComponent implements OnInit, OnDestroy {
  phoneNumber: string = '';
  isVideoCall: boolean = false;
  onWebSocketClose$ = this.webphoneQuery.select('onWebSocketClose');
  statusCodeEndCall$ = this.webphoneQuery.select("statusCodeEndCall");
  isCalling$: Observable<boolean>;
  callingPhoneNumber$: Observable<string>;
  callingPhoneName$: Observable<string>;
  
  loading = false;

  // Hotline selector
  hotlines: Hotline[] = [];
  selectedHotline: Hotline = null;
  showHotlineDropdown = false;

  constructor(
    private webphoneService: WebphoneService,
    private webphoneQuery: WebphoneQuery,
    private router: Router,
    private auth: AuthenticateStore,
    private hotlineQuery: HotlineQuery,
    private hotlineService: HotlineService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.isCalling$ = this.webphoneQuery.select(state => 
      state.callState !== CallingState.none
    );
    this.callingPhoneNumber$ = this.webphoneQuery.select(state => state.callingPhoneNumber);
    this.callingPhoneName$ = this.webphoneQuery.select(state => state.callingPhoneName);

    this.statusCodeEndCall$.pipe(takeUntil(this.destroy$)).subscribe((status) => {
      if (status == 486 || status == 603) {
       toastr.error("Thuê bao bận");
      }

      if (status == 401) {
        toastr.error("Thuê bao bị chặn");
      }
    });

    this.loadHotlines();
  }

  loadHotlines(): void {
    this.hotlines = this.hotlineQuery.getAll().filter(h => h.connection_method === 'direct' && h.status === 'P');
    const currentHotlineId = this.auth.snapshot?.extension?.hotline_id;
    if (currentHotlineId) {
      this.selectedHotline = this.hotlines.find(h => h.id === currentHotlineId) || this.hotlines[0] || null;
    } else {
      this.selectedHotline = this.hotlines[0] || null;
    }
  }

  toggleHotlineDropdown(): void {
    this.showHotlineDropdown = !this.showHotlineDropdown;
  }

  async selectHotline(hotline: Hotline): Promise<void> {
    if (hotline.id === this.selectedHotline?.id) {
      this.showHotlineDropdown = false;
      return;
    }
    try {
      await this.hotlineService.updateHotline(hotline.id);
      this.selectedHotline = hotline;
      toastr.success(`Đã chuyển hotline gọi ra: ${hotline.hotline}`);
    } catch (e) {
      toastr.error('Không thể chuyển hotline. Vui lòng thử lại.');
    }
    this.showHotlineDropdown = false;
  }

  addDigit(digit: string): void {
    this.phoneNumber += digit;
  }

  removeDigit(): void {
    if (this.phoneNumber.length > 0) {
      this.phoneNumber = this.phoneNumber.slice(0, -1);
    }
  }

  clearNumber(): void {
    this.phoneNumber = '';
  }

  async makeCall(): Promise<void> {
    if (!this.phoneNumber || this.phoneNumber.trim() === '') {
      return;
    }

    try {
      this.loading = true;
      await this.webphoneService.makeCall(this.phoneNumber.trim(), this.isVideoCall);
    } catch (error) {
      toastr.error(error.message || 'Không thể thực hiện cuộc gọi');
    } finally {
      this.loading = false;
    }
  }

  toggleVideoCall(): void {
    this.isVideoCall = !this.isVideoCall;
  }

  toContactPage(): void {
    this.router.navigateByUrl(`/s/${this.auth.currentAccountIndex()}/contacts`);
  }
}
